import { AppMessage } from "./app-message";
import { Localization } from "../enums/localization";

type IssueMessageType = "noJobs" | "jobsCompleted";

export class IssueMessage extends AppMessage {
  public buildingStructureId: number;
  public buildingStructureLabel: string;
  public numberOfIssues: number;
  public messageType: IssueMessageType;

  public getMessage(): string {
    const params = {
      count: this.numberOfIssues,
      building: this.buildingStructureLabel
    };

    const localization =
      this.numberOfIssues > 1
        ? this.messageType === "noJobs"
          ? Localization.OpenIssuesWithoutAnyJobs
          : Localization.OpenIssuesWithAllJobsCompleted
        : this.messageType === "noJobs"
          ? Localization.OpenIssueWithoutAnyJobs
          : Localization.OpenIssueWithAllJobsCompleted;

    return this.translateService.instant(localization, params);
  }

  public getRedirectUrl(): string {
    return `buildings/${this.buildingStructureId}/issues?${
      this.messageType === "noJobs"
        ? "statuses=Open&withoutAnyJobs=true&sortId=0"
        : "openIssuesWithCompletedActions=true"
    }`;
  }
}
